export default __webpack_public_path__ + "static/media/stadistics.e65e3067.svg";